import React from 'react';
import { Container } from '@material-ui/core';
import {UserTable} from './/user-table';
import Page from 'src/components/Page';


export const UserManagementScreen = ()=>{
  return (
    <Page title="User Management">
      <Container>
        <UserTable/>
      </Container>
    </Page>
  );
};